import { useState, useEffect } from 'react';
import { C, FONT } from './adminShared';
import { AdminPages } from './AdminPages';
import { MetaSpend } from './AdSpend';
import { getAdminUtmStats } from '../../utils/api';

// ── AD METRICS TAB ───────────────────────────────────────────────────────────
// The same funnel picture as Pages & Masterclass, PAID TRAFFIC ONLY, with the
// ad-spend section (moved from Traffic & UTM) underneath.
//
// DELIBERATELY NOT A FORK. The funnel half IS AdminPages with paidOnly set —
// one component, one layout, so the two tabs can be read side by side and can
// never drift apart. Only the spend section below is this tab's own.
//
// TWO DATE BASES ON ONE PAGE, ON PURPOSE, both stated on screen: the funnel
// figures above are floored at 14 Aug (the clean period); spend, watchers and
// stop rate below are ALL TIME back to June, because the pool the ads built is
// older than the tracking.
export const AdminAdMetrics = () => {
  const [utm, setUtm] = useState(null);
  const [utmFailed, setUtmFailed] = useState(false);

  // The funnel section above (AdminPages) owns its own timeframe state; this
  // just mirrors the resolved value so the spend section below can (a) fetch
  // /utm-stats for the SAME window and (b) know when to show the "Last 24
  // hours" honesty line. AdminPages fires this only when the timeframe
  // actually changes, not on every render — see its onTimeframeChange comment.
  // null until AdminPages reports its range — it now waits for the saved
  // "Opt-in Copy Change" marker before deciding, so fetching here on mount would
  // load "All time" first and then again.
  const [timeframe, setTimeframe] = useState(null);

  useEffect(() => {
    if (!timeframe) return;
    getAdminUtmStats(timeframe.from, timeframe.to)
      .then(res => setUtm(res.data))
      .catch(() => setUtmFailed(true));
  }, [timeframe?.from, timeframe?.to, !!timeframe]);

  return (
    <div style={{ fontFamily: FONT, color: C.text }}>
      <AdminPages paidOnly onTimeframeChange={setTimeframe} />

      <div style={{ marginTop: 28 }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: C.heading, marginBottom: 4 }}>
          What the ads cost
        </div>
        <div style={{ fontSize: 10.5, color: C.accent, lineHeight: 1.6, marginBottom: 10 }}>
          <strong style={{ color: C.text, fontWeight: 700 }}>All time</strong> — unlike the funnel
          figures above (floored at 14 Aug), spend and watcher history go back to June. The two
          periods differ on purpose: the warm pool the ads built is older than the landing tracking.
        </div>
        {utmFailed
          ? (
            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: '12px 14px', fontSize: 11.5, color: C.accent, lineHeight: 1.55 }}>
              Couldn’t load the spend figures — the Traffic API didn’t respond. The funnel figures
              above are unaffected; reload to try again.
            </div>
          )
          : <MetaSpend metaAds={utm?.metaAds} activeRangeId={timeframe?.range} />}
      </div>
    </div>
  );
};
